import { z } from 'zod';

export const editSireFormSchema = z.object({
  sireId: z.string().min(1, 'Sire ID is required'),
  name: z.string().min(1, 'Sire Name is required'),
  breedId: z.string().min(1, 'Breed is required'),
  breedReg: z.string().optional(),
  registrationNumber: z.string().optional(),
  regPrefix: z.string().optional(),
  cane: z.string().optional(),
  birth: z.date().optional().nullable(),
  sire: z.string().optional(),
  heparin: z.number().optional(),
  verified: z.enum(['Yes', 'No']).optional(),
});

export type EditSireFormValues = z.infer<typeof editSireFormSchema>;
